module.exports = __webpack_public_path__ + "img/XT-Accesorios.8b070831.png";